import React from 'react';

const TranscriptionTab = React.memo(({ inputText }) => {
  return (
    <div className="transcription-subtab">
      <h3>Rå transkriberad text</h3>
      <textarea
        style={{ width: "100%", minHeight: 200 }}
        readOnly
        value={inputText}
      />
    </div>
  );
});

TranscriptionTab.displayName = 'TranscriptionTab';

export default TranscriptionTab;